import { c as _c } from "react/compiler-runtime";
import { Image } from "@opensea/next-ui-kit";
import { classNames } from "@opensea/ui-kit";
export function ConstellationBackgroundLayerItemImage(t0) {
  const $ = _c(9);
  const {
    blur,
    imageUrl,
    subscribe,
    onSubscribe
  } = t0;
  const t1 = blur ? "z-0 opacity-75 blur-xl" : "z-10";
  let t2;
  if ($[0] !== t1) {
    t2 = classNames("-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 size-16 scale-150 rounded object-cover", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onSubscribe || $[3] !== subscribe) {
    t3 = () => {
      if (subscribe) {
        onSubscribe?.();
      }
    };
    $[2] = onSubscribe;
    $[3] = subscribe;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== imageUrl || $[6] !== t2 || $[7] !== t3) {
    t4 = <Image className={t2} frameTime={1} height={256} onLoad={t3} src={imageUrl} width={256} />;
    $[5] = imageUrl;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}